import * as React from 'react';
import { connect } from 'react-redux';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Components
// @ts-ignore
import ButtonLink from 'components/ButtonLink';

interface OwnProps {
    params: {
        [param: string]: any;
    };
    children: React.ReactNode;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = OwnProps & DispatchProps;

/**
 * A button component that adds params to qs when clicked, it does this for all roles.
 */
export class EveryoneButtonLink extends React.PureComponent<Props> {
    handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        const { params } = this.props;
        this.props.updateQueryString(params);
    };

    render(): React.ReactElement | null {
        const { children } = this.props;
        return <ButtonLink onClick={this.handleClick}>{children}</ButtonLink>;
    }
}

export default connect(
    null,
    { updateQueryString }
)(EveryoneButtonLink);
